// sweeps experiment

const WITH_SWEEPS = '1';

if (window.gtag) {
  window.gtag('event', 'optimize.callback', {
    name: 'IIxznoSFSuCWmLOnAUyJIw',
    callback: function(value, name) {
      if (value === WITH_SWEEPS) {
        const script = document.createElement('script');
        script.src = 'https://zrz.co/z-4124/i.js';
        document.head.appendChild(script);
      }
    }
  });
}
